import { PopupButton } from '@typeform/embed-react';
import React, { ReactNode } from 'react';
import { styled } from '~ui-kit/styled-components';

interface TypeFormButtonProps {
  typeformId: string;
  children: ReactNode;
  typeformHiddenFields?: Record<string, string>;
}

export function TypeFormButton({ children, typeformId, typeformHiddenFields }: TypeFormButtonProps): JSX.Element {
  return (
    <StyledButton id={typeformId} hidden={typeformHiddenFields}>
      {children}
    </StyledButton>
  );
}

const StyledButton = styled(PopupButton)`
  && {
    padding: 0;
    border: none;
    background: none;
    text-transform: none;
    height: 100%;
    width: 100%;
    box-shadow: none;
    align-items: flex-start;
    cursor: pointer;
  }
`;
